const style = {
  name: {
    color: `black`
  },
  userCount: {},
  permCount: {}
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/GroupTable/style/ColorBlind/group.js